document.addEventListener("DOMContentLoaded", () => {
  const noClickNavLinks = document.querySelectorAll(".nav-link--noclick");

  noClickNavLinks.forEach(noClickNavLink => noClickNavLink.addEventListener('click', () => preventClickOnLink(event)));

  function preventClickOnLink(event) {  
    event.preventDefault();
  }
});


document.addEventListener("DOMContentLoaded", () => {
  const menuDrawerCollapsibleHeaders = document.querySelectorAll(".menu-drawer__collapsible-header");

  menuDrawerCollapsibleHeaders.forEach(menuDrawerCollapsibleHeader => menuDrawerCollapsibleHeader.addEventListener('click', () => toggleMenuDrawerCollapsible(event)));

  function toggleMenuDrawerCollapsible(event) {  
    event.preventDefault();
    let target = event.target || event.srcElement;
    
    const collapsibleMenuId = target.getAttribute("data-collapsible-menu-id");
    let collapsibleMenu = document.getElementById(collapsibleMenuId);

    if (collapsibleMenu.style.display === "none") {
      collapsibleMenu.style.display = "block";
      target.classList.add('menu-drawer__collapsible-header--open');
    } else {
      collapsibleMenu.style.display = "none";
      target.classList.remove('menu-drawer__collapsible-header--open');
    }

  }
});